import { StreamInvocationMessage } from '@microsoft/signalr';
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface directPatientparam extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface directPatient { 

    Name:string,
    Door:string,
    Street:string,
    Landmark:string,
    City:string,
    Pincode:string,
    Mobile: string,
    Email:string,
    TenantId:string,
    BranchId:string,
    DistrictId:string,
    StateId:string,
    CountryId:string,
    createdDate:any;
    
    parameters?: directPatient[];
    links?: any;
}

export interface directPatientbillingMaster { 

    holdBillId:number;
    discountValue:number;
    discountAmount:number,
    taxAmount:number,
    netAmount:number,
    discountType:string,
    totalAmount:number,
    tenantId:string,
    branchId:string,
    taxPercentage:number,
    billDate:any,
    DpRegId:number,
    status:string,
    physicianId:string,
    paidAmount:number,
    balanceAmount:number,
    billNumber:number,
    emergencyFlag:string,
    woid:string,
    updatedBy:number,
    updatedDate:any,
    updatedIP:string,
    createdBy:number,
    createdDate:any,
    createdIP:string,
    cancelFlag:string,
    cancelReason:string,
    doneBy:number,
    doneDate:any,
    BillDet:directPatientbillingDetails[],
    CommonPayement:directPatientbillingCommonPayment[]

    parameters?: directPatientbillingMaster[];
    links?: any;
}

export interface directPatientbillingDetails { 
    billId:number,
    serviceId:string,
    serviceName:string,
    serviceCategoryName:string,
    rate:number,
    Quantity:number,
    charges:number,
    refMode:string,
    refEmpId:string,
    refClinicId:string,
    refDocId:string,
    othersName:string,
    othersPhone:string,
    othersAddress:string,
    serviceDiscountPercentage:number,
    serviceDiscountType:string,
    serviceDiscountAmount:number,
    serviceNetAmount:number,
    branchId:string,
    tenantId:string

    parameters?: directPatientbillingDetails[];
    links?: any;
}

export interface directPatientbillingCommonPayment { 
    cash:number,
    cardType: string,
    CardBank: string,
    creditCard: number,
    transactionNo: string,
    uPIPaymentID: string,
    uPIPayment: number,
    upiReferenceNo: string,
    paymentType:string,
    creditAmount: number,
    creditRefId: string,
    insuranceAmount: number,
    payerId: string,
    walletAmount: number,
    walletRefId: string,
    netBankAmt: number,
    netBankId: string,
    paymentDoneFrom:string,
    DpRegId:number,
    branchId:string,
    tenantId:string

    parameters?: directPatientbillingCommonPayment[];
    links?: any;
}

export abstract class directPatientData {
    abstract list(url: string): Observable<any>; 
    abstract getById(url: string): Observable<any>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract getall(url: string): Observable<any[]>;
    abstract create(url: string, data: any): Observable<any[]>;
    abstract getData(url: string, data: any): Observable<any[]>;
    abstract update(url: string, data: any): Observable<any>;
    abstract cancelBill(url: string, data): Observable<any>;
    
}
